import { AlertTriangle, Bug, Info, Star, User, Wrench } from 'lucide-react';
import { theme } from 'styles/theme/theme';

export * from './notification-type-labels';

export const typeOptions = [
  { value: 'all', label: 'Все типы' },
  { value: 'update', label: 'Обновление' },
  { value: 'bugfix', label: 'Исправления ошибок' },
  { value: 'maintenance', label: 'Тех. работы' },
  { value: 'info', label: 'Инфо' },
  { value: 'upcoming', label: 'Будущие обновления' },
  { value: 'known_issue', label: 'Известная проблема' },
  { value: 'user_event', label: 'Личные события' },
];

export const sortOptions = [
  { value: 'desc', label: 'Новые' },
  { value: 'asc', label: 'Старые' },
];

export const typeIconMap = {
  update: Star,
  bugfix: Bug,
  maintenance: Wrench,
  info: Info,
  upcoming: Info,
  known_issue: AlertTriangle,
  user_event: User,
};

export const typeColorMap = {
  update: theme.colors.AccentNaplesYellow,
  bugfix: theme.colors.error,
  maintenance: theme.colors.Gray,
  info: theme.colors.Gray,
  upcoming: theme.colors.AccentNaplesYellow,
  known_issue: theme.colors.AccentNaplesYellow,
  user_event: theme.colors.DarkBlue,
};
